import { React, useState, useEffect } from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import DotLoader from "react-spinners/DotLoader";

import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experince from './components/expirence/Experience'
import Projects from './components/projects/Projects'
import Contact from './components/contact/Contact'
import Error from "./components/Error/Error";

const App = () => {

  const [loading, setloading] = useState(false)

  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1500)
  }, [])

  return (
    <div>
      {loading ?
        (
          <DotLoader
            className="loader"
            color={'#1f1f38'}
            loading={loading}
            size={100}
          />
        ) :
        (
          <Router>
            <div className="body-div">
                <Nav />
                <Routes>
                  <Route path="/" element={<Header />}/>
                  <Route path="/about" element={<About />}/>
                  <Route path="/experince" element={<Experince />}/>
                  <Route path="/projects" element={<Projects />}/>
                  <Route path="/contact" element={<Contact />}/>
                  <Route path="*" element={<Error />}/>
                </Routes>
            </div>
          </Router>
        )
      }
    </div>
  );
};

export default App;
